import React from 'react';
import { Box } from '@mui/material';
import ReportsCatalog from '../components/reports/ReportsCatalog';

const ReportsLandingPage = () => {
  return (
    <Box>
      <ReportsCatalog />
    </Box>
  );
};

export default ReportsLandingPage;
